var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Sections")]),_c('ul',_vm._l((_vm.sections),function(section){return _c('li',{key:section.id},[_vm._v(_vm._s(section.title))])}))])}
var staticRenderFns = []

export { render, staticRenderFns }